// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_er3","cls2":"DebugPage-cls2_V7v DebugPage-cls1_er3"};